import { Email, Attachment } from 'app/entities/emails/emails-model';
import { OrganisationalEmail } from 'app/entities/emails/emails-model';
import { Injectable, EventEmitter } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { plainToClass } from 'class-transformer';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { Base64 } from 'app/shared/base64-encoder';



/**
* Service for entity email tab.
*/
@Injectable()
export class EntityEmailService {
    entityDetailsUpdated: EventEmitter<EntityIdDetails> = new EventEmitter();
    private entityIdDetails: EntityIdDetails;

    constructor(private requestService: ObservableRequestService) {
        this.entityIdDetails = new EntityIdDetails();
    }

    setEntityIdDetails(entityIdDetails: EntityIdDetails): void {
        this.entityIdDetails = entityIdDetails;
        this.entityDetailsUpdated.emit(this.entityIdDetails);
    }

    getEmails(entityId: number, offset: number, limit: number): Observable<any> {
        const emailurl = ConstantsService.EMAIL + '/' + entityId;
        const params = new URLSearchParams();

        params.set('offset', offset.toString());
        params.set('limit', limit.toString());
        return this.requestService.getRequest(emailurl, params).map(response => {
            if (response.arrResult) {
                return plainToClass(Email, response.arrResult as Object);
            } else {
                return response;
            }
        });
    };

    getRemoteEmails(password: string, offset: number, limit: number): Observable<any> {
        const hashcodedPassword = Base64.encodeBase64(password);
        const emailurl = ConstantsService.REMOTEMAIL;
        const params = {
            offset: offset.toString(),
            limit: limit.toString(),
            encodedString: hashcodedPassword
        };

        return this.requestService.postRequest(emailurl,
            JSON.stringify(params), this.requestService.getJSONContentType());
    };

    getEncodedString(passString: string): string {
        const encodedString = Base64.encodeBase64(passString);
        return encodedString;

    }

    saveEmailsInDatabase(organisationalEmail: OrganisationalEmail) {
        return this.requestService.postRequest(ConstantsService.IMPORT_EMAIL_DATABASE,
            JSON.stringify(organisationalEmail), this.requestService.getJSONContentType());
    }

    getEntityIdDetails(): EntityIdDetails {
        return this.entityIdDetails;
    }

    getAttachmentContent(emailId: any, attachmentId: number): Observable<any> {
        return this.requestService.downloadFile(ConstantsService.EMAIL + '/' + emailId + ConstantsService.FETCH_ATTACHMENT + '/' + attachmentId);
    }

}



// WEBPACK FOOTER //
// ./src/app/entities/emails/emails.service.ts